import { render, staticRenderFns } from "./WriteDialog.vue?vue&type=template&id=16df7487&scoped=true&"
import script from "./WriteDialog.vue?vue&type=script&lang=js&"
export * from "./WriteDialog.vue?vue&type=script&lang=js&"
import style0 from "./WriteDialog.vue?vue&type=style&index=0&id=16df7487&prod&lang=scss&scoped=true&"
import style1 from "./WriteDialog.vue?vue&type=style&index=1&id=16df7487&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16df7487",
  null
  
)

export default component.exports